import { create } from "zustand";

type FinancialDisclosureModalState = {
  isOpen: boolean;
  disclosureId: string | null;
  defaultValues: Partial<{
    personName: string;
    year: number;
    disclosureType: "campaign" | "conflict-of-interest";
    office: string;
    filingDate: Date;
    documentMediaId: string;
  }>;
  setIsModalOpen: (isOpen: boolean) => void;
  setDisclosureId: (id: string | null) => void;
  setDefaultValues: (
    values: Partial<{
      personName: string;
      year: number;
      disclosureType: "campaign" | "conflict-of-interest";
      office: string;
      filingDate: Date;
      documentMediaId: string;
    }>,
  ) => void;
};

export const useFinancialDisclosuresModal =
  create<FinancialDisclosureModalState>((set) => ({
    isOpen: false,
    disclosureId: null,
    defaultValues: {},
    setIsModalOpen: (isOpen) => set({ isOpen }),
    setDisclosureId: (id) => set({ disclosureId: id }),
    setDefaultValues: (values) => set({ defaultValues: values }),
  }));
